export const GetAllSubCategorization = async (resource) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/subcategorization`)
        .then(
            (response) => {
                result = response.body.subcategorization
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const GetSubcategorizationByClassification = async (resource, classification) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/subcategorization/find_by_classification/${classification}`)
        .then(
            (response) => {
                result = response.body.subcategorization
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const SubCategorizationFindByCategorizationId = async (resource,id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/subcategorization/find_by_categorizarion_id/${id}`)
        .then(
            (response) => {
                result = response.body.subcategorization
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}